<template>
	<el-dialog
		title="提示"
		:visible.sync="dialogVisible"
		width="100%"
        class="boxdop2"
		:before-close="handleClose">
		<div class="dialog-table">
            <comTable :config="tableConfig" :filterForm="filterForm" ref="table"></comTable>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="savePopFn(0)" v-text="`确定`"></el-button>
		</span>
	</el-dialog> 
</template>
<script>
import comTable from '@/components/firTable.vue'
export default {
    components: {comTable},
    props:{
        value:Object
    },
    data() {
        return {
            dialogVisible:true,
            filterForm: [
				{prop: 'id', label: '文章ID', pl: '请输入内容ID检索'},
				{prop: 'title', label: '文章标题', pl: '请输入文章标题检索'},
				{prop: 'type', label: '文章分类', pl: '请选择文章分类检索'},
				{prop: 'tags', label: '标签', pl: '请输入标签检索'},
				{prop: 'author', label: '创建人', pl: '请输入创建人检索'}
			],
            tableConfig:{
				url:'getArticleList',
				list:[
                    {type:'checkRidi',checkOn:'',checkProp:'id',width:'60px'},
					{label:'文章ID',prop:'id'},            
                    {label:'文章标题',prop:'title'},
                    {label:'文章分类',prop:'classify',clfn:da=>{
                        let classify = [];
                        try {
                            classify = JSON.parse(da.classify)
                        } catch (error) {
                            
                        }
                        return classify.join('/')
                    }},
                    {label:'标签',prop:'tags',type:'html',clfn:da=>{
						let arr = [];
						try {
							arr = JSON.parse(da.tags);
						} catch (error) {
							
						}
						let str = '';
						arr.map(e=>{
							str+=`<span class="tages">${e}</span>`
						})
						return str;
					}},    
                    {label:'存在关联跳转',prop:'relation_jump',clfn:da=>{
                        return da.relation_jump || 0
                    }},
                    {label:'创建人',prop:'creator'},
					{label:'创建时间',prop:'create_at'},
					// {label:'操作',type:'tool',btns:[
					// 	{label:'查看',clickFn:da=>{
					// 		this.lookBtn(da,'look')
					// 	}},

					// ]},

        

				
				]
			},
        }
    },
    created(){
        if(this.value.type){
            this.tableConfig.pr = {display_type:this.value.type}
        }
        
    },
    methods: {
        lookBtn(){

        },
        savePopFn () {
            this.$emit('sucss',this.tableConfig.list[0].objData)
		},
        handleClose(){
            this.$emit('close')
        }
    },
};
</script>
<style lang='scss'>
.boxdop2{
    height: 100vh;
}
.boxdop2 .el-dialog__body{
    height: calc(100vh - 60px);
}
.boxdop2 .dialog-table{
    height: 100%;
}
.boxdop2 .el-dialog__footer{
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
}
</style>